/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ProductMappingService } from './services/product-mapping.service';
import { ConfigService } from './services/config.service';
import { StockService } from './services/stock.service';
import { ProductService } from './services/product.service';
import { ProductMappingRequestService } from './services/product-mapping-request.service';
import { PriceService } from './services/price.service';
import { ProcessService } from './services/process.service';
import { ProcessItemService } from './services/process-item.service';
import { RootService } from './services/root.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ProductMappingService,
    ConfigService,
    StockService,
    ProductService,
    ProductMappingRequestService,
    PriceService,
    ProcessService,
    ProcessItemService,
    RootService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
